export default "__VITE_ASSET__a2caea88__"